// config.js
const config = {
  // Ambiente atual (development, production, test)
  env: process.env.NODE_ENV || 'development',

  // Configuração da API
  api: {
    // URL base da API
    baseURL: process.env.REACT_APP_API_URL || 'https://apinfsegone.goneweb.com.br',

    // Timeout para requisições em milissegundos
    timeout: 10000,

    // Endpoints específicos
    endpoints: {
      auth: {
        login: '/login',
        logout: '/logout',
      },
      boletos: {
        listar: '/webboletos',
        baixar: (id) => `/boletos/${id}/download`,
      },
      notasFiscais: {
        listar: '/webnfse',
        baixar: (id) => `/notas-fiscais/${id}/download`,
      }
    }
  },

  // Nomes das chaves no localStorage
  storage: {
    token: 'token',
    dadosUsuario: 'dadosUsuario'
  },

  // Configurações de rotas
  routes: {
    login: '/login',
    documentos: '/documentos',
    recuperarSenha: '/recuperar-senha'
  }
};

export default config;